<template>
  <div class="newNavTabs">
    <div class="nav">
      <div class="navMain">
        <div class="navItem"
             v-for="item in newNavData"
             :key="item.id">
          <div class="navTop">{{item.name}}</div>
          <div class="navBottom">
            <div class="navLevel2"
                 :class="{'active':item2.analyse_typ == $store.state.user.ActivedTab||(item2.analyse_typ == 'ner'&&isLabelAnalysis),'ner_arrow':item2.analyse_typ == 'ner','navLevelActive':item2.analyse_typ == 'ner'&&!showNavMask}"
                 v-for="item2 in item.chd"
                 :key="item2.name"
                 @click="handleTabClick(item2)"
                 @mouseenter="navMouseEnter(item2)"
                 @mouseleave="navMouseLeave(item2)">{{item2.title}}</div>
          </div>
        </div>
      </div>
      <div class="navSecond"
           v-loading="loading"
           @mouseenter="showNavMask = false"
           @mouseleave="navSecondMouseLeave">
        <div class="navLevel3">
          <div class="title">产品维度:</div>
          <div style="flex:1;display:flex;flex-wrap:wrap;">
            <div class="tabPane"
                 v-for="item,index in filterType('product')"
                 :key="item.name">
              <div class="itemLabel"
                   :class="{'active':item.analyse_typ == $store.state.user.ActivedTab}"
                   @mouseenter="handleMouseEnter(item,'product_'+index)"
                   @mouseleave="handleMouseLeave()"
                   @click="handleTabClick(item)">
                <div class="lb"
                     v-if="isShowEditIndex != 'product_'+index || tabNameValue != item.title">{{item.title}}</div>
                <div class="lb"
                     v-if="isShowEditIndex == 'product_'+index && tabNameValue == item.title">
                  <el-input size="mini"
                            style="width:80px"
                            placeholder="请输入内容"
                            @click.stop.native=""
                            v-model="newTabNameValue">
                  </el-input>
                  <i class="el-icon-check"
                     @click.stop="subEditTabName(item)"></i>
                  <i class="el-icon-close"
                     @click.stop="closeEditTabName()"></i>
                </div>
                <i class="el-icon-edit"
                   style="margin-left:4px;"
                   v-if="tabActiveIndex == 'product_'+index && isShowEditIndex != 'product_'+index && item.analyse_typ != 'CustomList'"
                   @click.stop="changeTabName(item,'product_'+index)"></i>
                <i class="iconfont icon-a-iconyincang2"
                   style="margin-left:4px;"
                   v-if="tabActiveIndex == 'product_'+index && isShowEditIndex != 'product_'+index && item.analyse_typ != 'CustomList'"
                   @click.stop="hideTab(item)"></i>
              </div>
            </div>
            <el-dropdown placement="bottom"
                         @command="showTab">
              <div class="save"
                   style="line-height:30px;"
                   v-show="filterHide('product').length>0">
                更多
              </div>
              <el-dropdown-menu slot="dropdown">
                <div v-if="filterHide('product').length>0">
                  <el-scrollbar style="height:100%">
                    <el-dropdown-item v-for="tag in filterHide('product')"
                                      :key="tag.name"
                                      :command="tag">{{tag.title}}</el-dropdown-item>
                  </el-scrollbar>
                </div>
                <div v-if="filterHide('product').length==0">
                  <el-dropdown-item disabled>暂无数据</el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="navLevel3">
          <div class="title">营销维度:</div>
          <div style="flex:1;display:flex;flex-wrap:wrap;">
            <div class="tabPane"
                 v-for="item,index in filterType('market')"
                 :key="item.name">
              <div class="itemLabel"
                   :class="{'active':item.analyse_typ == $store.state.user.ActivedTab}"
                   @mouseenter="handleMouseEnter(item,'market_'+index)"
                   @mouseleave="handleMouseLeave()"
                   @click="handleTabClick(item)">
                <div class="lb"
                     v-if="isShowEditIndex != 'market_'+index || tabNameValue != item.title">{{item.title}}</div>
                <div class="lb"
                     v-if="isShowEditIndex == 'market_'+index && tabNameValue == item.title">
                  <el-input size="mini"
                            style="width:80px"
                            placeholder="请输入内容"
                            @click.stop.native=""
                            v-model="newTabNameValue">
                  </el-input>
                  <i class="el-icon-check"
                     @click.stop="subEditTabName(item)"></i>
                  <i class="el-icon-close"
                     @click.stop="closeEditTabName()"></i>
                </div>
                <i class="el-icon-edit"
                   style="margin-left:4px;"
                   v-if="tabActiveIndex == 'market_'+index && isShowEditIndex != 'market_'+index && item.analyse_typ != 'CustomList'"
                   @click.stop="changeTabName(item,'market_'+index)"></i>
                <i class="iconfont icon-a-iconyincang2"
                   style="margin-left:4px;"
                   v-if="tabActiveIndex == 'market_'+index && isShowEditIndex != 'market_'+index && item.analyse_typ != 'CustomList'"
                   @click.stop="hideTab(item)"></i>
              </div>
            </div>
            <el-dropdown placement="bottom"
                         @command="showTab">
              <div class="save"
                   style="line-height:30px;"
                   v-show="filterHide('market').length>0">
                更多
              </div>
              <el-dropdown-menu slot="dropdown">
                <div v-if="filterHide('market').length>0">
                  <el-scrollbar style="height:100%">
                    <el-dropdown-item v-for="tag in filterHide('market')"
                                      :key="tag.name"
                                      :command="tag">{{tag.title}}</el-dropdown-item>
                  </el-scrollbar>
                </div>
                <div v-if="filterHide('market').length==0">
                  <el-dropdown-item disabled>暂无数据</el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="navLevel3">
          <div class="title">自定义分析:</div>
          <div style="flex:1;display:flex;flex-wrap:wrap;">
            <div class="tabPane"
                 v-for="item,index in filterType('custom')"
                 :key="item.name">
              <div class="itemLabel"
                   :class="{'active':item.name == $store.state.user.ActivedTab}"
                   @mouseenter="handleMouseEnter(item,'custom_'+index)"
                   @mouseleave="handleMouseLeave()"
                   @click="handleTabClick(item)">
                <div class="lb"
                     v-if="isShowEditIndex != 'custom_'+index || tabNameValue != item.title">{{item.title}}</div>
                <div class="lb"
                     v-if="isShowEditIndex == 'custom_'+index && tabNameValue == item.title">
                  <el-input size="mini"
                            style="width:80px"
                            placeholder="请输入内容"
                            @click.stop.native=""
                            v-model="newTabNameValue">
                  </el-input>
                  <i class="el-icon-check"
                     @click.stop="subEditTabName(item)"></i>
                  <i class="el-icon-close"
                     @click.stop="closeEditTabName()"></i>
                </div>
                <!-- <i class="el-icon-edit"
                 style="margin-left:4px;"
                 v-if="tabActiveIndex == 'custom_'+index && isShowEditIndex != 'custom_'+index && item.analyse_typ != 'CustomList'"
                 @click.stop="changeTabName(item,'custom_'+index)"></i> -->
                <i class="iconfont icon-a-iconyincang2"
                   style="margin-left:4px;"
                   v-if="tabActiveIndex == 'custom_'+index && isShowEditIndex != 'custom_'+index && item.analyse_typ != 'CustomList'"
                   @click.stop="hideTab(item)"></i>
              </div>
            </div>
            <el-dropdown placement="bottom"
                         @command="showTab">
              <div class="save"
                   style="line-height:30px;"
                   v-show="filterHide('custom').length>0">
                更多
              </div>
              <el-dropdown-menu slot="dropdown">
                <div v-if="filterHide('custom').length>0">
                  <el-scrollbar style="height:100%">
                    <el-dropdown-item v-for="tag in filterHide('custom')"
                                      :key="tag.name"
                                      :command="tag">{{tag.title}}</el-dropdown-item>
                  </el-scrollbar>
                </div>
                <div v-if="filterHide('custom').length==0">
                  <el-dropdown-item disabled>暂无数据</el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <div class="navMask"
             v-if="showNavMask"></div>
      </div>
    </div>
    <!-- <div class="navCrumb"
         @mouseleave="crumbMouseLeave"
         v-show="isShowNavCrumb">
      <div class="crumbBox">
        <div class="crumb crumb1"
             ref="crumb1"
             @mouseenter="crumbMouseEnter(1)">{{navCrumbData[0]}}</div>
        <div class="crumb crumb2"
             ref="crumb2"
             @mouseenter="crumbMouseEnter(2)">> {{navCrumbData[1]}}</div>
        <div class="crumb crumb3"
             ref="crumb3"
             v-if="navCrumbData[2]"
             @mouseenter="crumbMouseEnter(3)">> {{navCrumbData[2]}}</div>
      </div>
      <div class="downMenu"
           @mouseleave="menuMouseLeave(0)">
        <div class="menu menu1"
             v-show="menu.menu1"
             ref="menu1"
             :style="{ margin: menu.menu1Margin }">
          <div v-for="item in newNavData"
               :key="item.id"
               :class="{'menuActive':item.name == navCrumbData[0],'menuItemHover':menu.menu1Hover == item.id}"
               @mouseenter="menuMouseEnter(1,item)"
               @mouseleave="menuMouseLeave(1)"
               class="menuItem">{{item.name}} <i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="menu menu2"
             v-show="menu.menu2"
             ref="menu2"
             :style="{ margin: menu.menu2Margin }">
          <div v-for="item in menu2NavData"
               :key="item.analyse_typ"
               :class="{'menuActive':item.title == navCrumbData[1],'menuItemHover':menu.menu2Hover == item.analyse_typ}"
               @mouseenter="menuMouseEnter(2,item)"
               @mouseleave="menuMouseLeave(2)"
               @click="handleTabClick(item, 'crumb')"
               class="menuItem">{{item.title}} <i class="el-icon-arrow-right"
               v-if="item.analyse_typ == 'ner'"></i></div>
        </div>
        <div class="menu menu3"
             v-show="menu.menu3 && level3Data.length >0"
             ref="menu3"
             :style="{ margin: menu.menu3Margin }"
             @mouseleave="menuMouseLeave(3)">
          <div class="groupTitle"
               @click="toggleHeight(1)"
               v-show="filterType('product').length>0"><span>产品维度</span><i :class="[isCollapsed1 ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i></div>
          <div class="content-box"
               :class="{ 'height-zero': isCollapsed1 }">
            <div v-for="item in filterType('product')"
                 :key="item.name"
                 class="menuItem"
                 :class="{'menuActive':item.title == navCrumbData[2]}"
                 @click="handleTabClick(item)">{{item.title}}</div>
          </div>
          <div class="groupTitle"
               @click="toggleHeight(2)"
               v-show="filterType('market').length>0"><span>营销维度</span><i :class="[isCollapsed2 ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i></div>
          <div class="content-box"
               :class="{ 'height-zero': isCollapsed2 }">
            <div v-for="item in filterType('market')"
                 :key="item.name"
                 class="menuItem"
                 :class="{'menuActive':item.title == navCrumbData[2]}"
                 @click="handleTabClick(item, 'crumb')">{{item.title}}</div>
          </div>
          <div class="groupTitle"
               @click="toggleHeight(3)"
               v-show="filterType('custom').length>0"><span>自定义分析</span><i :class="[isCollapsed3 ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"></i></div>
          <div class="content-box"
               :class="{ 'height-zero': isCollapsed3 }">
            <div v-for="item in filterType('custom')"
                 :key="item.name"
                 class="menuItem"
                 :class="{'menuActive':item.title == navCrumbData[2]}"
                 @click="handleTabClick(item, 'crumb')">{{item.title}}</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>

</template>


<script>
export default {
  name: 'NavTabs',
  props: {
    navData: {
      type: Array,
      default: () => [],
    },
    hideTabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      showNavMask: true,
      newNavData: [
        {
          name: '核心指标',
          id: 1,
          chd: [
            {
              analyse_typ: 'BaseInfo',
              name: 'BaseInfo',
              origin_user: '',
              rule_id: '',
              title: '基本信息',
            },
          ],
        },
        {
          name: '营销指标',
          id: 2,
          chd: [
            {
              analyse_typ: 'CrowdPortrait',
              name: 'CrowdPortrait',
              origin_user: '',
              rule_id: '',
              title: '人群画像',
            },
            {
              analyse_typ: 'BrandList',
              name: 'BrandList',
              origin_user: '',
              rule_id: 'f5debfca-5585-473a-ab31-920fe54dd28e',
              title: '品牌榜',
            },
            {
              analyse_typ: 'TalentList',
              name: 'TalentList',
              origin_user: '',
              rule_id: '',
              title: '达人榜',
            },
            {
              analyse_typ: 'TopicAnalysis',
              name: 'TopicAnalysis',
              origin_user: '',
              rule_id: '',
              title: '话题榜',
            },
          ],
        },
        {
          name: '产品指标',
          id: 3,
          chd: [
            {
              analyse_typ: 'ner',
              name: 'ner',
              origin_user: '',
              rule_id: '',
              title: '标签分析',
            },
            {
              analyse_typ: 'CustomList',
              name: 'CustomList',
              origin_user: '',
              rule_id: '',
              title: '自定义分析',
            },
          ],
        },
        {
          name: 'AI+',
          id: 4,
          chd: [
            {
              analyse_typ: 'AiInterpret',
              name: 'AiInterpret',
              origin_user: '',
              rule_id: '',
              title: 'DeepSeek解读',
            },
          ],
        },
      ],
      level2Data: [
        'BaseInfo',
        'CrowdPortrait',
        'BrandList',
        'TalentList',
        'TopicAnalysis',
        'CustomList',
      ],
      level3Data: [],
      tabActiveIndex: -1,
      isShowEditIndex: -1,
      tabNameValue: '',
      newTabNameValue: '',
      //   navCrumbData: [],
      isShowNavCrumb: false,
      menu: {
        menu1: false,
        menu1Margin: '0px',
        menu1Hover: '',
        menu2: false,
        menu2Margin: '0px',
        menu2Hover: '',
        menu3: false,
        menu3Margin: '0px',
      },
      menu2NavData: [],
      menu3NavData: [],
      isCollapsed1: false,
      isCollapsed2: false,
      isCollapsed3: false,
      crumbType: false,
    }
  },
  methods: {
    filterType(typ) {
      let arr = _.filter(this.level3Data, function (o) {
        return o.tab_typ == typ
      })
      return arr
    },
    filterHide(typ) {
      let arr = _.filter(this.hideTabs, function (o) {
        return o.tab_typ == typ
      })
      return arr
    },
    handleTabClick(item, from) {
      if (from == 'crumb') {
        this.crumbType = true
      } else {
        this.crumbType = false
      }
      if (item.analyse_typ == 'ner') {
        return
      }
      this.$parent.editableTabsValue = item.name
      this.$parent.handleTabClick(item)
    },
    navMouseEnter(item) {
      if (item.analyse_typ != 'ner' && !this.isLabelAnalysis) {
        this.showNavMask = true
      } else {
        this.showNavMask = false
      }
    },
    navMouseLeave(item) {
      if (item.analyse_typ != 'ner' && !this.isLabelAnalysis) {
        this.showNavMask = true
      } else {
        this.showNavMask = false
      }
    },
    navSecondMouseLeave(e) {
      if (!e.relatedTarget || this.isLabelAnalysis) {
        return
      }
      this.showNavMask = true
    },
    handleMouseEnter(item, index) {
      this.tabActiveIndex = index
    },
    handleMouseLeave() {
      this.tabActiveIndex = -1
    },
    subEditTabName(item) {
      let obj = {
        from: item.title,
        to: this.newTabNameValue,
        name: item.name,
      }
      this.$parent.setTabNav('edit', obj)
    },
    closeEditTabName() {
      this.tabNameValue = ''
      this.newTabNameValue = ''
      this.isShowEditIndex = -1
    },
    changeTabName(item, index) {
      this.newTabNameValue = item.title
      this.tabNameValue = item.title
      this.isShowEditIndex = index
    },
    hideTab(item) {
      let obj = {
        from: '',
        to: true,
        name: item.name,
      }
      this.$parent.setTabNav('hide', obj)
    },
    showTab(item) {
      let obj = {
        from: '',
        to: false,
        name: item.analyse_typ ? item.analyse_typ : item.rule_id,
      }
      this.$parent.setTabNav('hide', obj)
    },
    crumbMouseEnter(val) {
      const width1 = this.$refs.crumb1.offsetWidth
      const width2 = this.$refs.crumb2.offsetWidth
      this.menu.menu1Hover = ''
      this.menu.menu2Hover = ''
      if (val == 1) {
        this.menu.menu1 = true
        this.menu.menu2 = false
        this.menu.menu3 = false
      } else if (val == 2) {
        this.menu.menu1 = false
        this.menu.menu2 = true
        this.menu.menu2Margin = `0 0 0 ${width1 + 20}px`
        this.menu.menu3 = false
        if (this.navCrumbData[2]) {
          this.menu.menu3 = true
          this.menu.menu3Margin = `0`
          this.menu2NavData = this.newNavData[2].chd
        } else {
          let obj = _.find(this.newNavData, (o) => {
            return o.name == this.navCrumbData[0]
          })
          this.menu2NavData = obj.chd
        }
      } else if (val == 3) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = true
        this.menu.menu3Margin = `0 0 0 ${width1 + width2 + 20}px`
      }
    },
    crumbMouseLeave(event) {
      const childEl = this.$el.querySelector('.downMenu')
      const enteredChild = childEl.contains(event.relatedTarget)
      // 如果没有进入子元素，或 relatedTarget 为 null（完全离开）
      if (!enteredChild || !event.relatedTarget) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = false
        this.menu.menu1Hover = ''
        this.menu.menu2Hover = ''
      }
    },
    menuMouseEnter(val, data) {
      if (val == 1) {
        this.menu.menu2 = true
        // this.menu.menu2Margin = `${data.id * 28 - 28}px 1px 0`
        this.menu.menu2Margin = `0`
        if (data && data.chd) {
          this.menu2NavData = data.chd
          this.menu.menu1Hover = data.id
        }
        this.menu.menu3 = false
        this.menu3NavData = []
        this.menu.menu2Hover = ''
      } else if (val == 2) {
        this.menu.menu2Hover = ''
        this.menu.menu3Margin = `0`
        if (data && data.analyse_typ == 'ner') {
          this.menu.menu3 = true
          this.menu3NavData = this.level3Data
          this.menu.menu2Hover = 'ner'
        } else {
          this.menu.menu3 = false
          this.menu3NavData = []
        }
      } else if (val == 3) {
      }
    },
    menuMouseLeave(val) {
      if (val == 0) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = false
      } else if (val == 3 && !this.menu.menu2) {
        this.menu.menu1 = false
        this.menu.menu2 = false
        this.menu.menu3 = false
      }
    },
    findParentByAnalyseTyp(data, targetAnalyseTyp) {
      return _.find(data, (item) => {
        return _.some(item.chd, { analyse_typ: targetAnalyseTyp })
      })
    },
    toggleHeight(val) {
      if (val == 1) {
        this.isCollapsed1 = !this.isCollapsed1
      } else if (val == 2) {
        this.isCollapsed2 = !this.isCollapsed2
      } else if (val == 3) {
        this.isCollapsed3 = !this.isCollapsed3
      }
    },
  },
  created() {
    this.$eventBus.$on('showNavCrumb', (val) => {
      if (this.crumbType) {
        this.crumbType = false
        return
      }
      this.isShowNavCrumb = val
    })
    const _this = this
    if (this.$store.state.user.loginInfo.is_partner) {
      this.newNavData = _.filter(this.newNavData, function (o) {
        return o.id != 4
      })
    }
    this.level3Data = _.filter(this.navData, function (o) {
      return !_this.level2Data.includes(o.analyse_typ)
    })
  },
  computed: {
    navCrumbData() {
      let arr = ['', '', '']
      const result = this.findParentByAnalyseTyp(
        this.newNavData,
        this.$store.state.user.ActivedTab
      )
      if (result) {
        arr[0] = result.name
        arr[1] = _.find(result.chd, (item) => {
          return item.analyse_typ == this.$store.state.user.ActivedTab
        }).title
        this.menu2NavData = result.chd
      } else {
        //未找到匹配项表示为产品/营销/自定义的nav
        this.menu2NavData = this.newNavData[2].chd
        let title = ''
        let titleObj = _.find(this.level3Data, (o) => {
          return (
            o.analyse_typ == this.$store.state.user.ActivedTab ||
            o.name == this.$store.state.user.ActivedTab
          )
        })
        if (titleObj) {
          title = titleObj.title
        } else {
          let obj = _.find(this.hideTabs, (o) => {
            return (
              o.analyse_typ == this.$store.state.user.ActivedTab ||
              o.name == this.$store.state.user.ActivedTab ||
              o.rule_id == this.$store.state.user.ActivedTab
            )
          })
          title = obj.title
        }
        arr = ['产品指标', '标签分析', title]
      }
      return arr
    },
    isLabelAnalysis() {
      let data = this.level3Data.concat(this.hideTabs)
      let obj = _.find(data, (o) => {
        return (
          o.analyse_typ == this.$store.state.user.ActivedTab ||
          o.name == this.$store.state.user.ActivedTab ||
          o.rule_id == this.$store.state.user.ActivedTab
        )
      })
      if (obj) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    '$store.state.user.loginInfo': {
      handler(newVal, oldVal) {
        if (newVal.is_partner) {
          this.newNavData = _.filter(this.newNavData, function (o) {
            return o.id != 4
          })
        }
      },
    },
    '$store.state.user.ActivedTab': {
      handler(newVal, oldVal) {
        if (!this.level2Data.includes(newVal) || this.isLabelAnalysis) {
          this.showNavMask = false
        } else {
          this.showNavMask = true
        }
      },
    },
    navData: {
      handler(newVal) {
        let _this = this
        if (newVal.length == 0) {
          this.loading = true
          return
        }
        this.level3Data = _.filter(newVal, function (o) {
          return !_this.level2Data.includes(o.analyse_typ)
        })
        this.closeEditTabName()
        setTimeout(() => {
          this.loading = false
        }, 1000)
      },
    },
  },
}
</script>

<style lang="less" scoped>
.newNavTabs {
  padding-top: 8px;
  background: #f3f4f6;
  .iconfont {
    font-size: 12px;
  }
  .nav {
    margin-bottom: 20px;
    .navMain {
      display: flex;
      .navItem {
        margin-right: 50px;
        .navTop {
          padding: 6px 20px;
          border-top-right-radius: 14px;
          background: #3a63f3;
          color: #fff;
          font-size: 14px;
          text-align: center;
          display: inline-block;
          white-space: nowrap;
        }
        .navBottom {
          background: #fff;
          color: #000;
          font-size: 14px;
          display: flex;
          padding: 0 10px;
          .navLevel2 {
            padding: 10px 10px;
            cursor: pointer;
          }
          .ner_arrow {
            position: relative;
          }
          .ner_arrow::before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-10px);
            width: 0;
            height: 0;
            border-left: 14px solid transparent;
            border-right: 14px solid transparent;
            border-bottom: 14px solid #fff;
          }
          .navLevel2:hover {
            color: #3a63f3;
          }
          .navLevel2.active {
            color: #3a63f3;
            font-weight: 600;
          }
          .navLevel2.navLevelActive {
            color: #3a63f3;
          }
        }
      }
    }
    .navSecond {
      width: 100%;
      padding: 20px 30px;
      margin-top: 20px;
      box-sizing: border-box;
      background: #fff;
      position: relative;
      .navMask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        opacity: 0.6;
      }
      .navLevel3 {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        .title {
          margin-right: 20px;
          line-height: 30px;
          width: 80px;
          font-size: 14px;
        }
        .save {
          font-size: 12px;
        }
        .tabPane {
          flex-wrap: nowrap;
          margin-bottom: 4px;
          .itemLabel {
            padding: 4px 12px;
            border: 1px solid #e9e9eb;
            color: #303133;
            border-radius: 4px;
            margin-right: 10px;
            font-size: 12px;
            cursor: pointer;
            .lb {
              display: inline-block;
            }
          }
          .itemLabel.active {
            color: #3a63f3;
            border-color: #3a63f3;
          }
        }
      }
      .navLevel3:nth-of-type(3) {
        margin-bottom: 0;
      }
    }
  }
  .navCrumb {
    position: relative;
    padding: 0 0 10px;
    .crumbBox {
      display: flex;
      .crumb {
        margin-right: 6px;
        cursor: pointer;
        font-weight: 600;
      }
      .crumb:hover {
        color: #3a63f3;
      }
    }
    .downMenu {
      position: absolute;
      left: 0;
      top: 24px;
      display: flex;
      //   align-items: flex-start;
      z-index: 99;
      .menu {
        text-align: left;
        min-width: 120px;
        width: auto;
        border: 1px solid #e4e7ed;
        background: #fff;
        box-shadow: 4px 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        .menuItem {
          padding: 0 24px 0 15px;
          height: 34px;
          line-height: 34px;
          box-sizing: border-box;
          cursor: pointer;
          font-size: 14px;
          position: relative;
          color: #a4a4a4;
          i {
            position: absolute;
            right: 6px;
            top: 0;
            line-height: 34px;
          }
        }
        .menuItem:hover {
          color: #3a63f3;
          background: #f5f7fa;
        }
        .menuItemHover {
          color: #3a63f3;
          background: #f5f7fa;
        }
      }
      .menu2 {
        margin-left: 1px;
        margin-right: 1px;
        margin-top: 20px;
      }
      .menu3 {
        min-width: 140px;
        margin-top: 40px;
        max-height: 224px;
        overflow-y: auto;
        .groupTitle {
          padding: 4px 6px;
          user-select: none;
          color: #333;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          i {
            padding-top: 2px;
          }
        }
      }
      .content-box {
        height: auto;
        overflow: hidden;
        transition: height 0.3s ease;
      }

      .height-zero {
        height: 0;
      }
      .menuActive {
        color: #3a63f3 !important;
      }
    }
    .active {
      color: #3a63f3;
    }
  }
}
</style>
